import { useContext } from "react"
import { DashBoardContext } from "./dashboard.context";


export const useDashboard = () => {
    const  context = useContext(DashBoardContext)
    if (context === undefined){
        throw new Error(`Component is not inside LeadContext scope`);
    }
    return context
}